export const merchantFormTheme = {
  hint: 'palette.primary.60',
  img: {
    borderColor: 'transparent',
    borderRadius: '8px',
    borderWidth: '0px',
  },
  tag: {
    bg: 'palette.tertiary.10',
    borderColor: 'palette.tertiary.20',
    borderRadius: '16px',
    borderWidth: '1px',
    text: 'palette.neutral.70',
  },
};
